import {
  //  FC,useState
  useEffect,
} from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import {
  Logout,
  AuthPage,
  // useAuth
} from '../modules/auth'
import { App } from '../App'
import { onAuthStateChanged } from 'firebase/auth'
import AffiliateTracker from '../../utils/AffiliateTracker'
// import { decodeToken, isExpired } from "react-jwt";
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import { userProfile } from '../../redux/action/auth'
import { initializeAccountState } from '../../redux/action/account'
import ARScene from '../experiences/ARScene'
import ExternalRedirect from './ExternalRedirect'
import LogRocket from 'logrocket';
import {auth} from '../../firebase'
import MetaPixel from '../../utils/metaPixel'
import { initializeLogger } from '../../utils/logger'

// import Camera from '../../examples/image-tracking/nft/camera'
// import { auth } from '../../firebase';
// import { onAuthStateChanged } from 'firebase/auth';
const { PUBLIC_URL } = process.env

const AppRoutes: React.FC = () => {
  // const [user, setUser] = React.useState<null | Record<string, any>>(null);
  const [loading, setLoading] = React.useState(true)
  const [token, setToken] = React.useState(false)
  const dispatch = useDispatch()
  const environment = process.env.REACT_APP_ENVIRONMENT;
  
  // Get user data from Redux to pass to logger
  const userData = useSelector((state: any) => state.Auth?.authProfile?.userData)

  // React.useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
  //     setUser(currentUser);
  //     dispatch(userProfile(currentUser?.uid))
  //     setLoading(false);
  //   });
  //   return () => unsubscribe();
  // }, []);

  // Update logger when user data changes (provides admin status)
  useEffect(() => {
    if (userData) {
      console.log('AppRoutes: Updating logger with user admin status:', userData?.protected?.isAdmin)
      initializeLogger(userData)
    }
  }, [userData])

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log('AppRoutes: Auth state changed:', user ? 'User logged in' : 'User logged out')
      setLoading(true)
      
      if (user) {
        console.log('AppRoutes: Setting up user session for:', user.uid)
        
        // Clear any old account state and set fresh user session
        const currentStoredUserId = localStorage.getItem('userId')
        const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
        const originalAdminId = localStorage.getItem('originalAdminId')
        const originalUserId = localStorage.getItem('originalUserId')
        
        // Only clear account state if:
        // 1. Different user logging in AND
        // 2. NOT in admin mode AND
        // 3. NOT in account switching mode (originalUserId doesn't exist or doesn't match Firebase user)
        // 4. OR in admin mode but the Firebase user doesn't match the original admin ID
        const isDifferentUser = currentStoredUserId !== user.uid
        const isAccountSwitching = originalUserId === user.uid
        const isValidAdminSession = isAdminMode && originalAdminId === user.uid
        
        if (isDifferentUser && !isAccountSwitching && !isValidAdminSession) {
          // Different user logging in, clear old account state
          console.log('AppRoutes: Different user detected, clearing old account state')
          localStorage.removeItem('activeAccountId')
          localStorage.removeItem('activeAccountType')
          localStorage.removeItem('originalUserId')
          localStorage.removeItem('isAdminMode')
          localStorage.removeItem('originalAdminId')
          localStorage.removeItem('adminPermissionMode')
        } else if (isValidAdminSession) {
          console.log('AppRoutes: Admin viewing different account, preserving admin state')
        } else if (isAccountSwitching) {
          console.log('AppRoutes: User in account switching mode, preserving account state')
        } else {
          console.log('AppRoutes: Same user, preserving existing state')
        }
        
        // Set userId to Firebase user ID if not in admin mode or account switching mode
        if (!isAdminMode && !isAccountSwitching) {
          console.log('AppRoutes: Setting userId to Firebase user ID:', user.uid)
          localStorage.setItem('userId', user.uid)
        }
        
        const uid = localStorage.getItem('mimicId') || localStorage.getItem('userId') || user?.uid
        
        try {
          console.log('AppRoutes: Loading user profile for:', uid)
          dispatch(userProfile(uid))
          console.log('AppRoutes: User profile loaded successfully')
          
          // Initialize account state - make it completely non-blocking
          console.log('AppRoutes: Initializing account state')
          dispatch(initializeAccountState()).catch((error: any) => {
             console.warn('Failed to initialize account state:', error)
          })
          
          console.log('AppRoutes: Setting token to true and loading to false')
          setToken(true)
          setLoading(false)
          
        } catch (error) {
          console.error('Error loading user profile:', error)
          // Even if user profile fails, still set token to true to allow app to load
          setToken(true)
          setLoading(false)
        }
        
        // LogRocket setup
        if (environment === 'production') {
          if (!localStorage.getItem('mimicId')) {
            LogRocket.identify(user?.uid, {
              name: user?.displayName || 'Unknown',
              email: user?.email || 'Unknown',
            })
          }
        }
        
      } else {
        console.log('AppRoutes: User logged out, cleaning up')
        localStorage.removeItem('userId')
        localStorage.removeItem('activeAccountId')
        localStorage.removeItem('activeAccountType')
        localStorage.removeItem('isAdminMode')
        localStorage.removeItem('originalAdminId')
        localStorage.removeItem('adminPermissionMode')
        setToken(false)
        setLoading(false)
      }
    })

    return () => unsubscribe();
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <div>Loading...</div>
  }

  const hostname = window.location.hostname


const ARSceneWrapper = ({ isPreview }) => {
  // You can also use useParams here if you need to access :id
  return <ARScene isPreview={isPreview} />;
};

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <AffiliateTracker />
      {environment === 'production' && <MetaPixel/>}
      <Routes>
        <Route element={<App />}>
          {hostname === 'qr2xr.com' ? (
            <>
              <Route path='/ar/:id' element={<ARSceneWrapper isPreview={false} />} />
              <Route path='*' element={<ExternalRedirect to='https://skanteq.com' />} />
            </>
          ) : token ? (
            <>
              <Route path='/ar/:id' element={<ARScene />} />
              <Route path='error/*' element={<ErrorsPage />} />
              <Route path='logout' element={<Logout />} />
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='/ar/:id' element={<ARScene />} />
              <Route path='error/*' element={<ErrorsPage />} />
              <Route path='logout' element={<Logout />} />
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
